import React, { useContext, useEffect } from "react";
import "./form.scss";
import { Data } from "../App";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import FormBody from "./FormBody";
import FormStatic from "./FormStatic";
import "../common/page404.scss";

export default function Form() {
  const { selectedList } = useContext(Data);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (selectedList.length === 0) {
    return (
      <>
        <Helmet>
          <title>生地サンプル請求 | 国産ソファブランド NOYES</title>
          <meta
            name="viewport"
            content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
          />
        </Helmet>

        <div className="not_found">
          <h1>
            Not Selected<span>生地が選択されていません</span>
          </h1>
          <Link to="/">生地一覧に戻る</Link>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Helmet>
          <title>
            フォームの入力 | 生地サンプル請求 | 国産ソファブランド NOYES
          </title>
          <meta
            name="viewport"
            content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
          />
        </Helmet>

        <div className="form_wrapper">
          {/* タイトルから生地サムネまで */}
          <FormStatic selectedList={selectedList} />
          {/* フォーム本体 */}
          <FormBody selectedList={selectedList} />
        </div>
      </>
    );
  }
}
